<template>
    <div class="section-cookies" :class="color" v-if="showAppCookies()">
        <layout-contained :class="padding">
            <content-text
                html="We use video cookies to embed videos, analytical cookies to improve our website, and necessary cookies to enable core functionality."
                :contentColor="contentColor"
                :textCentered="textCentered"
            ></content-text>
            <div class="mt-4 mb-1 sm:mb-2 flex flex-row space-x-3" :class="!!textCentered ? 'justify-center' : ''">
                <button-primary buttonText="Accept" :buttonClick="acceptDefaultCookies"></button-primary>
                <button-primary
                    buttonColor="bg-zinc-700 hover:bg-zinc-600 text-white"
                    buttonText="Reject"
                    :buttonClick="rejectDefaultCookies"
                ></button-primary>
            </div>
        </layout-contained>
    </div>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'SectionCookies',
    props: {
        padding: {
            required: false,
            default: 'py-5 sm:py-6',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-zinc-100',
        },
        contentColor: {
            required: false,
            type: String,
            default: 'text-zinc-700',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
    computed: {
        ...mapState(useCookiesStore, {
            cookies: 'cookies',
        }),
    },
    methods: {
        ...mapActions(useCookiesStore, {
            acceptDefaultCookies: 'acceptDefaultCookies',
            enableCookie: 'enableCookie',
        }),
        showAppCookies: function () {
            return !this.cookies.asked;
        },
        rejectDefaultCookies: function () {
            this.enableCookie('asked');
        },
    },
};
</script>
